import React from "react";
import workData from "../data/work";

const Work = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center mb-7 underline font-serif text-3xl font-bold text-purple-700">
          Work Experience:
        </h1>

        {workData.map((w) => (
          <div className="pt-6" key={w.title}>
            <div className="sm:text-lg">
              <div className="justify-center items-center flex bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
                <span className="">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <div className="font-bold text-xl">{w.title}</div>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
              <div className="">
                <div className="my-2 sm:pl-4 space-x-7">
                  <ul className="space-y-2">
                    {[
                      { label: "Name of Company:", value: w.company },
                      { label: "Location:", value: w.location },
                      { label: "Job Role:", value: w.role },
                      { label: "Duration:", value: w.duration },
                    ].map((d) => (
                      <div className="sm:flex sm:space-x-4" key={d.label}>
                        <li className="sm:flex">
                          <i className="fa-solid fa-circle mr-2 text-xs pt-2"></i>
                          <span className="font-semibold">{d.label}</span>
                        </li>
                        <li>{d.value}</li>
                      </div>
                    ))}
                    {w.learning && (
                      <>
                        <div className="sm:flex sm:space-x-4">
                          <li>
                            <i className="fa-solid fa-circle mr-2 text-xs"></i>
                            <span className="font-semibold">My Learning:</span>
                          </li>
                        </div>
                        <div className="pl-6">
                          {w.learning.map((l) => (
                            <div className="sm:flex sm:space-x-4" key={l}>
                              <li>
                                <i className="fa-regular fa-circle mr-2 text-xs"></i>
                                <span>{l}</span>
                              </li>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Work;
